import moduleName from './main.module';
import './_collections/base.js';
import './_collections/day_collections.provider.js';
import './_collections/space_collections.provider.js';
import './_components/angular_hal.js';
import './_components/angular_storage.js';
import './_components/angular_ui_map.js';
import './_components/local_data.js';
import './_components/moment_extensions.js';
import './_components/string_polyfills.js';
import './_constants/alerts.constant.js';
import './_constants/app_config.value.js';
import './_constants/bbug.js';
import './_constants/keycode.constant.js';
import './_constants/route_states.constant.js';
import './_filters/add.filter.js';
import './_filters/address_multi_line.filter.js';
import './_filters/adress_single_line.filter.js';
import './_filters/clear_timezone.filter.js';
import './_filters/currency.filter.js';
import './_filters/datetime.filter.js';
import './_filters/distance.filter.js';
import './_filters/exclude_days.filter.js';
import './_filters/format_answer.filter.js';
import './_filters/icurrency.filter.js';
import './_filters/international_number.filter.js';
import './_filters/interpolate.filter.js';
import './_filters/ipretty_price.filter.js';
import './_filters/key_translate.filter.js';
import './_filters/label_number.filter.js';
import './_filters/local_phone_number.filter.js';
import './_filters/map_lat_long.filter.js';
import './_filters/nl2br.filter.js';
import './_filters/pretty_price.filter.js';
import './_filters/props.filter.js';
import './_filters/rag.filter.js';
import './_filters/range.filter.js';
import './_filters/raw_currency.filter.js';
import './_filters/round_up.filter.js';
import './_filters/snake_case.filter.js';
import './_filters/spaces_remaining.filter.js';
import './_filters/start_from.filter.js';
import './_filters/strip_postcode.filter.js';
import './_filters/time_period_from_seconds.filter.js';
import './_filters/time_period.filter.js';
import './_filters/time.filter.js';
import './_filters/twelve_hour_time.filter.js';
import './_filters/word_characters_and_spaces.filter.js';
import './_functions/strings.js';
import './_functions/utils.js';
import './_helpers/BaseModelExtended.js';
import './_helpers/bb_include.directive.js';
import './_helpers/PaginatedController.js';
import './_models/address_model.service.js';
import './_models/affiliate_model.service.js';
import './_models/answer_model.service.js';
import './_models/base_model.service.js';
import './_models/basket_item_model.service.js';
import './_models/basket_model.service.js';
import './_models/bb_collection_model.service.js';
import './_models/bb_model.service.js';
import './_models/bookable_item_model.service.js';
import './_models/bulk_purchase_model.service.js';
import './_models/business_question_model.service.js';
import './_models/category_model.service.js';
import './_models/client_details_model.service.js';
import './_models/client_model.service.js';
import './_models/clinic_model.service.js';
import './_models/company_model.service.js';
import './_models/company_settings_model.service.js';
import './_models/day_model.service.js';
import './_models/deal_model.service.js';
import './_models/event_chain_model.service.js';
import './_models/event_group_model.service.js';
import './_models/event_model.service.js';
import './_models/event_sequence_model.service.js';
import './_models/event_ticket_model.service.js';
import './_models/external_purchase_model.service.js';
import './_models/image_model.service.js';
import './_models/item_details_model.service.js';
import './_models/item_model.service.js';
import './_models/items_model.service.js';
import './_models/login_model.service.js';
import './_models/main.run.js';
import './_models/membership_level_model.service.js';
import './_models/opening_hours_model.service.js';
import './_models/package_item_model.service.js';
import './_models/paginiation_model.service.js';
import './_models/payment_callbacks_model.service.js';
import './_models/person_model.service.js';
import './_models/pre_paid_booking_model.service.js';
import './_models/product_model.service.js';
import './_models/purchase_item_model.service.js';
import './_models/purchase_total_model.service.js';
import './_models/question_model.service.js';
import './_models/reason_model.service.js';
import './_models/resource_model.service.js';
import './_models/service_model.service.js';
import './_models/slot_model.service.js';
import './_models/space_model.service.js';
import './_models/survey_question_model.service.js';
import './_models/time_slot_model.service.js';
import './_services/address_list.service.js';
import './_services/alert.service.js';
import './_services/app.service.js';
import './_services/basket.service.js';
import './_services/bb_google_maps.service.js';
import './_services/bb_service_children.service.js';
import './_services/block_time_options.provider.js';
import './_services/breadcrumb.service.js';
import './_services/bulk_purchase.service.js';
import './_services/category.service.js';
import './_services/client_details.service.js';
import './_services/client.service.js';
import './_services/clinic.service.js';
import './_services/company_search_interceptor.service.js';
import './_services/company_store.service.js';
import './_services/company.service.js';
import './_services/custom_text.service.js';
import './_services/datetime_utilities.service.js';
import './_services/day.service.js';
import './_services/deal.service.js';
import './_services/dialog/dialog.service.js';
import './_services/error.service.js';
import './_services/event_chain.service.js';
import './_services/event_group.service.js';
import './_services/event_sequence.service.js';
import './_services/event.service.js';
import './_services/form_data_store.service.js';
import './_services/form_transform.provider.js';
import './_services/general_options.provider.js';
import './_services/geolocation.service.js';
import './_services/item_details.service.js';
import './_services/item.service.js';
import './_services/loading.service.js';
import './_services/login.service.js';
import './_services/membership_levels.service.js';
import './_services/modal_form/book_form.controller.js';
import './_services/modal_form/check_schema.js';
import './_services/modal_form/edit_form.controller.js';
import './_services/modal_form/modal_form.service.js';
import './_services/modal_form/new_form.controller.js';
import './_services/mutex.service.js';
import './_services/package_item.service.js';
import './_services/paginiation.service.js';
import './_services/path_helper.service.js';
import './_services/path_svc.service.js';
import './_services/person_selection.service.js';
import './_services/person.service.js';
import './_services/product.service.js';
import './_services/purchase_total.service.js';
import './_services/query_string.service.js';
import './_services/question.service.js';
import './_services/reason.service.js';
import './_services/recaptcha.service.js';
import './_services/resource.service.js';
import './_services/scroll_intercepter.service.js';
import './_services/service.service.js';
import './_services/slot_dates.service.js';
import './_services/slot.service.js';
import './_services/space.service.js';
import './_services/sso.service.js';
import './_services/staff_priorities.provider.js';
import './_services/template_svc.service.js';
import './_services/time_slot_permutation/time_slot_permutation.service.js';
import './_services/time_slot.service.js';
import './_services/time.service.js';
import './_services/unwrap.js';
import './_services/utility/accessibility.service.js';
import './_services/utility/calendar_utility.service.js';
import './_services/utility/observer.service.js';
import './_services/utility/responsive.service.js';
import './_services/utility/sass_variables.service.js';
import './_services/validator.service.js';
import './_services/viewport_size.service.js';
import './_translations/en.js';
import './-config/entry.module.js';
import './-config/environment/environment.constant.js';
import './-config/font-awesome/font-awesome.config.js';
import './-config/main.module.js';
import './-config/schema-form/schema_form.config.js';
import './-http-tracker/http_tracker.js';
import './-i18n/_services/i18n_options.provider.js';
import './-i18n/_services/locale.service.js';
import './-i18n/_services/runtime_translate.provider.js';
import './-i18n/_translations/en.js';
import './-i18n/entry.module.js';
import './-i18n/language-picker/language_picker.directive.js';
import './-i18n/main.config.js';
import './-i18n/main.module.js';
import './-i18n/main.run.js';
import './-i18n/time-zone/custom_time_zones.constant.js';
import './-i18n/time-zone/time_zone_options.service.js';
import './-i18n/time-zone/time_zone_override.provider.js';
import './-i18n/time-zone/time_zone_select.component.js';
import './-i18n/time-zone/time_zone_utils.service.js';
import './-i18n/time-zone/time_zone.service.js';
import './-inputs/card-security-code/card_security_code.directive.js';
import './-inputs/credit-card-number/credit_card_number.directive.js';
import './-inputs/currency-filed/currency_field.directive.js';
import './-inputs/entry.module.js';
import './-inputs/focus/focus.directive.js';
import './-inputs/form/form.directive.js';
import './-inputs/input-group-manager/input_group_manager.directive.js';
import './-inputs/input-group/input_group.directive.js';
import './-inputs/main.module.js';
import './-inputs/match-input/match_input.directive.js';
import './-inputs/ng-max/ng_max.directive.js';
import './-inputs/ng-min/ng_min.directive.js';
import './-inputs/question-label/question_label.directive.js';
import './-inputs/question-line/question_line.directive.js';
import './-inputs/question-link/question_link.directive.js';
import './-inputs/question-set/question_set.directive.js';
import './-inputs/question-setup/question_setup.directive.js';
import './-inputs/question/question.controller.js';
import './-inputs/question/question.directive.js';
import './-toggle-switch/entry.module.js';
import './-toggle-switch/main.module.js';
import './-toggle-switch/toggle-switch/toggle_switch.directive.js';
import './-ui-select/entry.module.js';
import './-ui-select/main.module.js';
import './-ui-select/ui-select-choices-lazyload/ui_select_choices_lazyload.directive.js';
import './-ui-select/ui-select-choices-listener/ui_select_choices_listener.directive.js';
import './-uib/_services/runtime_uib_modal.provider.js';
import './-uib/entry.module.js';
import './-uib/main.module.js';
import './-uib/main.run.js';
import './-utilities/entry.module.js';
import './-utilities/main.module.js';
import './-utilities/options/options.provider.js';
import './accessibility/aria_hide_on_load.directive.js';
import './address-map/address_map.directive.js';
import './addresses/addresses.directive.js';
import './api-url/api_url.directive.js';
import './app-version/app_version.directive.js';
import './autofocus/autofocus.directive.js';
import './background-image/background_image.directive.js';
import './blur-on-return/blur_on_return.directive.js';
import './booking-export/bb_booking_export.directive.js';
import './capacity-view/capacity_view.directive.js';
import './capitalize-first-letter/capitalize_first_letter.directive.js';
import './comm-pref/comm_pref.directive.js';
import './content/content.directive.js';
import './count-ticket-types/count_ticket_types.directive.js';
import './date-directive/date.directive.js';
import './date-split/date_split.directive.js';
import './date-time-picker/date_time_picker.directive.js';
import './datepicker-popup/datepicker_popup.directive.js';
import './debounce/debounce.directive.js';
import './dynamic-footer/dynamic_footer.directive.js';
import './entry.module.js';
import './fb-login/fb_login.directive.js';
import './file-upload/file_upload.directive.js';
import './focus-on/focus_on.directive.js';
import './form-data-store/form_data_store.directive.js';
import './form-resettable/form_resettable.directive.js';
import './gdpr-consent/gdpr-consent.component.js';
import './gdpr-consent/gdpr-consent.controller.js';
import './get-availability/get_availability.directive.js';
import './header/header.directive.js';
import './include/include.directive.js';
import './int-tel-number/int_tel_number.directive.js';
import './loading/loading.directive.js';
import './local-number/local_number.directive.js';
import './main.config.js';
import './main.module.js';
import './main.run.js';
import './main.vendors.js';
import './merge-duplicate-question/merge_duplicate_questions.directive.js';
import './modal/modal.directive.js';
import './ng-confirm-click/ng_confirm_click.directive.js';
import './ng-delayed/ng_delayed.directive.js';
import './ng-initial/ng_initial.directive.js';
import './ng-options/ng_options.directive.js';
import './pad-with-zeros/pad_with_zeros.directive.js';
import './popover/popover.directive.js';
import './postcode-lookup/postcode_lookup.directive.js';
import './price-filter/bb_price_filter.directive.js';
import './pricepicker/pricepicker.directive.js';
import './print-page/print_page.directive.js';
import './raise-alert-when-invalid/raise_alert_when_invalid.directive.js';
import './resettable/resettable.directive.js';
import './scoped/scoped.directive.js';
import './script/script.directive.js';
import './scroll-to/scroll_to.directive.js';
import './slot-grouper/slot_grouper.directive.js';
import './time-zone/time_zone.directive.js';
import './toggle-edit/toggle_edit.directive.js';
import './valid-include/ng_valid_include.directive.js';
import './wait-for/wait_for.directive.js';
export default moduleName;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/entry.module.js